import { permissaoUtils } from '@core/util/permissaoUtil';
import { Tooltip } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { useKeycloak } from '@react-keycloak/web';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import * as authActions from 'app/auth/store/actions';
import { LoginModais } from 'app/main/login';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import { GlobalContext } from 'app/store/globalcontext/GlobalContext';
import { getTenant } from 'app/utils/enviromentUtil';
import { decrypt } from 'app/utils/geralUtil';
import React, { useContext, useState } from 'react';
import { FaRegBuilding, FaRegUserCircle } from 'react-icons/fa';
import { HiOutlineKey } from 'react-icons/hi';
import { MdExitToApp } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

function UserMenu() {
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.user);
  const { keycloak } = useKeycloak();
  const [userMenu, setUserMenu] = useState(null);
  const [, setUsuarioAtual] = useContext(GlobalContext).usuarioAtual;
  const [, setModal] = useContext(GlobalContext).modal;
  const [, setModalEmpresa] = useContext(GlobalContext).modalEmpresa;
  const history = useHistory();

  const tenant = getTenant();
  const showItemGestaoEnvio =
    !process.env.REACT_APP_TENANT_FATUREMAIS || tenant === process.env.REACT_APP_TENANT_FATUREMAIS;

  const showError = (message) => {
    dispatch(MessageActions.showMessage({ message, variant: 'error' }));
  };

  const userMenuClick = (event) => {
    setUserMenu(event.currentTarget);
  };

  const userMenuClose = () => {
    setUserMenu(null);
  };

  const handleShowUsuario = async () => {
    setModal('visualizacaoUsuario');
    setUserMenu(null);

    const user = await usuarioApi.buscarUuidUsuarioLogado();
    setUsuarioAtual(user.data);
  };

  const handleShowEmpresa = () => {
    if (permissaoUtils.minhaEmpresa().visualizar) {
      setModalEmpresa('visualizarEmpresa');
      setUserMenu(null);
    } else {
      showError('Você não possui permissão para acessar esta tela.');
    }
  };

  const handleShowAlterarSenha = () => {
    setModal(LoginModais.alterarSenha);
    setUserMenu(null);
  };

  const handleGestaoEnvio = () => {
    if (permissaoUtils.gestaoEnvio().visualizar) {
      history.push('/gestaoEnvio');
      setUserMenu(null);
    } else {
      showError('Você não tem permissão de acesso nessa funcionalidade.');
    }
  };

  return (
    <>
      <Button className="h-64 stepPerfil" onClick={userMenuClick}>
        {user.data.photoURL ? (
          <Avatar className="" alt="user photo" src={user.data.photoURL} />
        ) : (
          <Avatar className="">{user.data.displayName[0]?.charAt(0)}</Avatar>
        )}

        <div
          className="flex-col mx-12 items-start"
          style={{
            maxWidth: '200px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <Tooltip title={user.data.displayName}>
            <Typography component="span" className="normal-case font-600">
              {user.data.displayName}
            </Typography>
          </Tooltip>
          {/* <Typography className="text-11 capitalize" color="textSecondary">
            {user.role.toString()}
          </Typography> */}
        </div>

        <Icon className="text-16 hidden sm:flex" variant="action">
          keyboard_arrow_down
        </Icon>
      </Button>

      <Popover
        open={Boolean(userMenu)}
        anchorEl={userMenu}
        onClose={userMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
        {!user.role || user.role.length === 0 ? (
          <>
            <MenuItem component={Link} to="/login" role="button">
              <ListItemIcon className="min-w-40">
                <Icon>lock</Icon>
              </ListItemIcon>
              <ListItemText primary="Login" />
            </MenuItem>
            <MenuItem component={Link} to="/register" role="button">
              <ListItemIcon className="min-w-40">
                <Icon>person_add</Icon>
              </ListItemIcon>
              <ListItemText primary="Register" />
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem onClick={handleShowUsuario} role="button">
              <ListItemIcon className="min-w-40">
                <FaRegUserCircle size={22} style={{ color: '#585858' }} />
              </ListItemIcon>
              <ListItemText primary="Meu perfil" />
            </MenuItem>
            <MenuItem onClick={handleShowEmpresa} role="button">
              <ListItemIcon className="min-w-40">
                {/* <Icon>mail</Icon> */}
                <FaRegBuilding size={22} style={{ color: '#585858' }} />
              </ListItemIcon>
              <ListItemText primary="Minha empresa" />
            </MenuItem>
            <MenuItem onClick={handleShowAlterarSenha} role="button">
              <ListItemIcon className="min-w-40">
                <HiOutlineKey size={22} style={{ color: '#585858' }} />
              </ListItemIcon>
              <ListItemText primary="Alterar senha" />
            </MenuItem>
            {showItemGestaoEnvio && (
              <MenuItem onClick={handleGestaoEnvio} role="button">
                <ListItemIcon className="min-w-40">
                  <ServicoIcon color="#585858" size={22} />
                </ListItemIcon>
                <ListItemText primary="Gestão de envios" />
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                let logoutUrl = keycloak.createLogoutUrl();

                if (!keycloak.idToken) {
                  let idTokenEncrypted = localStorage.getItem('IDT');
                  let idToken = decrypt(idTokenEncrypted);

                  logoutUrl = logoutUrl.replace('id_token_hint=undefined', `id_token_hint=${idToken}`);
                }

                dispatch(authActions.logoutUser());
                userMenuClose();
                window.location = logoutUrl;
              }}
            >
              <ListItemIcon className="min-w-40">
                <MdExitToApp size={22} style={{ color: '#585858' }} />
              </ListItemIcon>
              <ListItemText primary="Sair" />
            </MenuItem>
          </>
        )}
      </Popover>
    </>
  );
}

export default UserMenu;
